import { Tabs } from "InnoUI/components";
import theme from "theme";
import SC from "./style";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import AddUpdateRevision from "../AddUpdateRevision";
import { useEffect, useState } from "react";
import RevisionTable from "./RevisionTable";
import HistoryTable from "./HistoryTable";
import { apiGet, apiPost } from "api/callApi";
import FileDetailsAction from "./FileDetailsAction";
import GetPermission from "./GetPermission";
import { userAccessType } from "utils/lookUpTable";
import { readFromSessionStorage } from "utils/helper";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import CheckPermissionWrapper from "components/CheckPermissionWrapper";
import InnoIcons from "@InnoIcons/";
import NewTab from "components/NewTab";
import FileViewer from "./FileViewer";

const FileDetailsView = (props) => {
  const { isDrawer = false, fileData = {}, onClose = () => {} } = props;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const [openModalView, setOpenModalView] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [modalRowData, setModalRowData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedTab, setSelectedTab] = useState(2);
  const [allDetilsData, setAllDetilsData] = useState([]);
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  // read URL params
  const paramFileId = searchParams.get("fileId");
  const fileId = fileData.id ?? paramFileId;

  const navigate = useNavigate();

  useEffect(() => {
    const redirectUrl = readFromSessionStorage("submitSend");
    if (redirectUrl) {
      sessionStorage.removeItem("submitSend");
      navigate(redirectUrl);
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    console.log(newValue, "newValue");

    setSelectedTab(newValue);
  };

  const allDetails = async () => {
    try {
      const response = await apiGet(`/v1/file/allfiles/${fileId}`, false);

      console.log(response, "response");

      if (response?.data) {
        setAllDetilsData(response.data);
      } else {
        console.error("No data in API response:", response);
        setAllDetilsData([]);
      }
    } catch (error) {
      console.error("Error fetching file details:", error);
      setAllDetilsData([]);
    }
  };

  useEffect(() => {
    if (fileId) {
      allDetails();
    } else {
      console.error("Invalid fileId:", fileId);
    }
  }, [fileId, type]);

  const tabData = [
    { value: 2, label: "Viewer" },
    { value: 0, label: "Revision" },
    { value: 1, label: "History" },
  ];

  const getHistory = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet(
        `/v1/file/gethistory/${allDetilsData[0]?.parentId}`,
        false,
      );
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.log("Error", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (allDetilsData[0]?.parentId) {
      getHistory();
    }
  }, [allDetilsData[0]?.parentId]);

  return (
    <>
      {!isDrawer && (
        <>
          <CustomBreadcrumb />
          <div style={{ marginTop: "50px" }}>
            <SC.FilterContainer>
              <OccupantFilterDropdown />
            </SC.FilterContainer>
          </div>
        </>
      )}

      {isDrawer && (
        <SC.DrawerTitlesContainer style={{ position: "sticky" }}>
          <SC.DrawerTitles>{`View `}</SC.DrawerTitles>
          <SC.CloseIcon>
            <InnoIcons.CloseIcon onClick={onClose} />
          </SC.CloseIcon>
        </SC.DrawerTitlesContainer>
      )}

      <CheckPermissionWrapper>
        {({ permission }) => (
          <>
            {permission >= userAccessType.read && (
              <>
                {!isDrawer && (
                  <SC.LeasingLayout>
                    <GetPermission folderId={allDetilsData[0]?.folderId} />
                  </SC.LeasingLayout>
                )}
                <div>
                  <FileDetailsAction
                    fileDetilsData={allDetilsData}
                    reloadData={allDetails}
                    getHistory={getHistory}
                    folderId={allDetilsData[0]?.folderId}
                    fileId={fileId}
                    isDrawer={isDrawer}
                  />
                </div>

                <div style={{ marginLeft: "15px" }}>
                  <NewTab
                    tabs={tabData}
                    selectedValue={selectedTab}
                    onChange={handleTabChange}
                  />
                </div>
                {selectedTab === 0 && (
                  <div
                    style={{
                      borderTop: `1px solid ${theme.colors.bordertask}`,
                    }}
                  >
                    <RevisionTable allDetilsData={allDetilsData} />
                  </div>
                )}
                {selectedTab === 1 && (
                  <div
                    style={{
                      borderTop: `1px solid ${theme.colors.bordertask}`,
                    }}
                  >
                    <HistoryTable data={data} />
                  </div>
                )}

                {selectedTab === 2 && (
                  <div
                    style={{
                      borderTop: `1px solid ${theme.colors.bordertask}`,
                      padding: "15px",
                    }}
                  >
                    <FileViewer allDetilsData={allDetilsData} fileId={fileId} />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </CheckPermissionWrapper>

      {openModalView && allDetilsData[0] && (
        <AddUpdateRevision
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          projectId={allDetilsData[0].projectId}
          folderId={allDetilsData[0].folderId}
          parentId={allDetilsData[0]?.parentId}
          folderData={modalRowData}
          setModalRowData={setModalRowData}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      )}
    </>
  );
};

export default FileDetailsView;
